export enum LoadingState {
    Loading = 0,
    Ready = 1,
    Error = 2,
    NotFound = 3
}
